import React from 'react';
import { GitBranch, X } from 'lucide-react';
import { useOpenWorkspace } from '../../hooks/useOpenWorkspace';

/*
 * Shown to the owner once, after the sign-up cards and before the Room: where
 * should the code live? Connecting happens in the Workspace (Settings → Code &
 * ownership), so the buttons hand over there; Later goes on to the Room and
 * the same door stays in Settings → Connectors.
 */
export const ConnectGitPrompt: React.FC<{
  clientId: string | null;
  onLater: () => void;
  onConnect: () => void;
}> = ({ clientId, onLater, onConnect }) => {
  const { opening, open } = useOpenWorkspace();
  const connect = () => {
    void open(clientId, `/customer/workspace?workspaceId=${encodeURIComponent(clientId || '')}&settings=code`);
    onConnect();
  };
  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-[#18191d]/40 p-6" onMouseDown={(e) => { if (e.target === e.currentTarget) onLater(); }}>
      <div className="w-[min(560px,100%)] rounded-[16px] border border-[#e7e7e4] bg-white p-7 shadow-[0_24px_60px_rgba(15,23,42,0.24)]">
        <div className="flex items-start justify-between gap-4">
          <div>
            <p className="m-0 text-[11px] font-semibold uppercase tracking-[0.14em] text-[#777982]">One more thing, when you are ready</p>
            <h2 className="mt-2 text-[24px] font-bold leading-[1.2] text-[#18191d]">Where should your code live?</h2>
          </div>
          <button type="button" onClick={onLater} aria-label="Close" className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-[#dedede] text-[#666971]">
            <X className="h-4 w-4" />
          </button>
        </div>
        <p className="mt-3 text-[14px] leading-[22px] text-[#666971]">
          Connect your company&rsquo;s GitHub or GitLab once and every build lands in your repositories, on a branch, as a pull request. Until then Agents Anywhere keeps each build in a private repository of its own.
        </p>
        <p className="mt-2 text-[13px] leading-[20px] text-[#92949d]">
          Only you, as the owner, can connect it. It opens in your Workspace; this tab carries on to your Room.
        </p>
        <div className="mt-5 flex flex-wrap gap-2">
          <button type="button" onClick={connect} disabled={opening || !clientId} className="inline-flex items-center gap-2 rounded-full bg-[#18191d] px-5 py-2.5 text-[14px] font-semibold text-white disabled:opacity-50 whitespace-nowrap">
            <GitBranch className="h-4 w-4" /> Connect GitHub or GitLab
          </button>
          <button type="button" onClick={onLater} className="rounded-full border border-[#dedede] bg-white px-5 py-2.5 text-[14px] font-semibold text-[#18191d]">
            Do this later
          </button>
        </div>
        <p className="m-0 mt-4 text-[12.5px] text-[#92949d]">Later lives in Settings → Connectors → Code → Manage in Workspace.</p>
      </div>
    </div>
  );
};

export default ConnectGitPrompt;
